import { IReference } from './IReference';
import { ReferencePathDirection } from './IReferencePath';

/**
 * Funzione che ritorna vero se la reference passata come parametro
 * è un riferimento al padre.
 */
export function isReferencePathParent(reference: IReference) {
  return (
    reference.path.some(p => p.direction === ReferencePathDirection.Parent) &&
    !reference.path.some(p => p.direction === ReferencePathDirection.Root)
  );
}
